import { Trans } from '@lingui/react/macro';
import { MoneyRecord, TireQuoteItemTireRecordCustomer } from '@navio/nsdk';
import { formatCurrencyAmount, getDimensionsLoadSpeedString, getTireBrandName } from 'noddi-util';

interface TirePriceSummaryProps {
  tire: TireQuoteItemTireRecordCustomer;
  quantity: number;
  lineGross: MoneyRecord;
}

export const TirePriceSummary = ({ tire, quantity, lineGross }: TirePriceSummaryProps) => {
  return (
    <div key={tire.id}>
      <div className='flex justify-between gap-4'>
        <div className='flex flex-col'>
          <p>
            {getTireBrandName(tire.tireInventory.tire)} - {tire.tireInventory.tire.model}
          </p>
          <p className='text-sm text-muted-foreground'>{getDimensionsLoadSpeedString(tire.tireInventory.tire)}</p>
        </div>
        <p>{formatCurrencyAmount({ money: lineGross })}</p>
      </div>
      <div className='mb-2 flex justify-end'>
        <p className='text-black/70'>
          {quantity} <Trans>pcs</Trans>
        </p>
      </div>
    </div>
  );
};
